import * as Yup from "yup";
import { AccountTypeEnum } from "../../../graphql/supergraphEnums";
import { isIndividualAccountType } from "../../../utils/account_types";
import { createAccountTypeSchema } from "../../AccountTypeForm/schemas";

export const createDeclarationSchema = (
  currentStep: number,
  showOwnershipPercentage: boolean,
  minPercentageThreshold: number,
  showExtendedTypes?: boolean,
) => {
  if (currentStep === 1) {
    return createAccountTypeSchema(showExtendedTypes || false);
  }

  return Yup.object().shape({
    accountType: Yup.mixed<AccountTypeEnum>().required("Account type is required"),
    firstName: Yup.string().when("accountType", {
      is: (value: AccountTypeEnum) => isIndividualAccountType(value),
      then: (schema) => schema.required("First name is required"),
      otherwise: (schema) => schema.strip(),
    }),
    middleName: Yup.string().when("accountType", {
      is: (value: AccountTypeEnum) => isIndividualAccountType(value),
      then: (schema) => schema,
      otherwise: (schema) => schema.strip(),
    }),
    lastName: Yup.string().when("accountType", {
      is: (value: AccountTypeEnum) => isIndividualAccountType(value),
      then: (schema) => schema.required("Last name is required"),
      otherwise: (schema) => schema.strip(),
    }),
    legalBusinessName: Yup.string().when("accountType", {
      is: (value: AccountTypeEnum) => !isIndividualAccountType(value),
      then: (schema) => schema.required("Legal business name is required"),
      otherwise: (schema) => schema.strip(),
    }),
    ownershipPercentage: Yup.number().when([], {
      is: () => showOwnershipPercentage,
      then: (schema) =>
        schema
          .required("Ownership percentage is required")
          .min(
            minPercentageThreshold,
            `The minimum ownership percentage is ${minPercentageThreshold}%`,
          )
          .max(100, "Ownership percentage cannot exceed 100%"),
      otherwise: (schema) => schema.strip(),
    }),
  });
};
